"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepTypes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const memoize_weak_1 = __importDefault(require("memoize-weak"));
const getNodeType_1 = __importDefault(require("./getNodeType"));
const getAllowedNextActionTypes = () => ['write', 'search', 'filter', 'paths_group'];
exports.stepTypes = {
    read: {
        label: 'Trigger',
        blurb: 'Trigger',
        isNode: true,
        allowedNextTypes: getAllowedNextActionTypes,
    },
    write: {
        label: 'Action',
        blurb: 'Action',
        isNode: true,
        allowedNextTypes: getAllowedNextActionTypes,
    },
    search: {
        label: 'Search',
        blurb: 'Search',
        isNode: true,
        allowedNextTypes: getAllowedNextActionTypes,
    },
    search_or_write: {
        label: 'Search or Create',
        blurb: 'Search or Create',
        isNode: true,
        allowedNextTypes: getAllowedNextActionTypes,
    },
    filter: {
        label: 'Filter',
        blurb: 'Filter',
        isNode: true,
        api: 'FilterAPI',
        allowedNextTypes: getAllowedNextActionTypes,
    },
    begin: {
        allowedNextTypes() {
            return ['read'];
        },
    },
    activate: {
        allowedNextTypes() {
            return [];
        },
        blurb: 'Activate',
    },
    end: {
        allowedNextTypes() {
            return [];
        },
    },
    paths_group: {
        label: 'Paths',
        blurb: 'Paths',
        isNode: true,
        api: 'BranchingAPI',
        allowedNextTypes: () => [],
    },
};
const createStep = (type, options) => {
    return lodash_1.default.extend({
        isBegin: false,
        isEnd: false,
    }, options, {
        type,
        isNode: (exports.stepTypes[type] && exports.stepTypes[type].isNode) || false,
    });
};
const getStepFromNode = (node) => createStep(getNodeType_1.default(node), {
    nodeId: node.id,
    selected_api: node.selected_api,
    action: node.action,
});
const stepsFromNodes = memoize_weak_1.default((nodes) => {
    const steps = nodes.map(getStepFromNode);
    return lodash_1.default.flatten(steps);
});
exports.default = stepsFromNodes;
